module.exports = __webpack_public_path__ + "img/galery10.3e948907.jpg";